import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Row, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { dateFormat } from '../../../utils';
import { useState } from 'react';
import { SelectMultiGovernment } from "../../../components/selects";

interface IProps {
  formField: any;
  form: any;
  onReset: () => void;
  onSearch: () => void;
}

export const FilterFinancialIndicators = (props: IProps) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(null);

  const handleStartDateChange = (date: any) => {
    setStartDate(date);
  };

  const disableEndDate = (current: any) => {
    return current && current.isBefore(startDate, 'day');
  };

  return (
    <Form form={props.form} layout='vertical'>
      <Row gutter={10}>
        <Space>
          <Form.Item
            label={t('titles.governments')}
            name={props.formField.governmentIds}
            style={{width: '330px'}}
          >
            <SelectMultiGovernment/>
          </Form.Item>
          <Form.Item
            label={t('general.start_date_period')}
            name={props.formField.periodStart}
          >
            <DatePicker
              format={dateFormat}
              placeholder={t('general.select_date')}
              onChange={handleStartDateChange}
            />
          </Form.Item>
          <Form.Item
            label={t('general.end_date_period')}
            name={props.formField.periodEnd}
          >
            <DatePicker
              format={dateFormat}
              placeholder={t('general.select_date')}
              disabledDate={disableEndDate}
            />
          </Form.Item>
        </Space>
        <div style={{ marginTop: 30 }}>
          <Button
            type="primary"
            shape="default"
            size="middle"
            icon={<SearchOutlined />}
            style={{ marginRight: 'auto' }}
            onClick={props.onSearch}
          >
            {t('general.search')}
          </Button>
          <Button
            size="small"
            type="link"
            onClick={props.onReset}
            style={{ color: "orange" }}
          >
            {t('general.reset')}
          </Button>
        </div>
      </Row>
    </Form>
  );
};